import Input from 'src/components/Input/Input';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { setDateRangeY } from 'src/store/slices/analyticSlices';

export const SelectDateYAxis = ({ selectOptions }) => {
  const dispatch = useAppDispatch();
  const { dateY } = useAppSelector((s) => s.analyticSlices);
  const defaultValue = dateY
    ? selectOptions.find((option) => option.groupBy === dateY)
    : selectOptions[1];
  const [selectValue, setSelectValue] = React.useState(defaultValue);

  const handleDateChange = (e) => {
    dispatch(
      setDateRangeY({
        dateY: e.groupBy,
      }),
    );
    setSelectValue(e);
  };
  return (
    <div className={'input-container text-[.88rem] min-w-[140px] analytic-date'}>
      <Input
        type={'select'}
        selectOptions={selectOptions}
        value={selectValue}
        dropdownClassName={'!py-1'}
        onChange={(e) => {
          handleDateChange(e);
        }}
      />
    </div>
  );
};
